import getInviteLink from './getInviteLink';
import getPublicUrl from './getPublicUrl';

export default function getOrganizationInviteLink(inviteCode?: string | null) {
  return getInviteLink({
    inviteCode,
    kind: 'organization',
    publicUrl: getPublicUrl(),
  });
}
